import dynamic from "next/dynamic";
import PersonasTabsConfig from "./personas-tabs-config";
import PersonasTabsAdvancedConfig from "./personas-tabs-advanced-config";
const PersonasTabsComponent = dynamic(()=>import("./personas-tabs-component"));
export default {
    PersonasTabsComponent,
    PersonasTabsConfig,
    PersonasTabsAdvancedConfig
};
